import React from "react";
import { FC } from "react";
import { Container, Nav, Navbar, Offcanvas } from "react-bootstrap";
import { Coins } from "./coins";
import { useCoins } from "../queries/completion-queries";
import { useStage } from "../queries/stage-queries";
import { faHourglass } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const Header: FC = () => {

    const { coins } = useCoins()
    const { currentStage } = useStage()

    return (
        <Navbar key={'nav-bar'} expand={false} className="bg-body-tertiary">
            < Container fluid >
                <Navbar.Brand href="/">
                    <img
                        src="/img/logo.png"
                        width="50"
                        height="50"
                        className="d-inline-block align-top"
                        alt="React Bootstrap logo"
                    />
                </Navbar.Brand>
                <Nav className="justify-content-center flex-grow-1 pe-3 d-flex flex-row gap-4">
                    <Nav.Link href="/missions">
                        <Coins coins={coins} />
                    </Nav.Link>
                    <Nav.Link href="/stats">
                        <img
                            src={currentStage?.icon}
                            width="40"
                            height="40"
                            className="d-inline-block align-top rounded-circle p-1 bg-secondary"
                            alt="React Bootstrap logo"
                        />
                    </Nav.Link>
                </Nav>
                <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-false`} />
                <Navbar.Offcanvas
                    id={`offcanvasNavbar-expand-false`}
                    aria-labelledby={`offcanvasNavbarLabel-expand-false`}
                    placement="end"
                >
                    <Offcanvas.Header closeButton>
                        <Offcanvas.Title id={`offcanvasNavbarLabel-expand-false`}>
                            <Navbar.Brand href="/">
                                <img
                                    src="/img/logo.png"
                                    width="50"
                                    height="50"
                                    className="d-inline-block align-top"
                                    alt="React Bootstrap logo"
                                />
                            </Navbar.Brand>
                            <span className="ps-3 mt-5 fs-1">Ascentinel</span>
                        </Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                        <Nav className="justify-content-end flex-grow-1 pe-3">
                            <Nav.Link href="/">
                                <img
                                    src="/img/Challenger.png"
                                    width="35"
                                    height="35"
                                    className="d-inline-block align-top me-2"
                                    alt="React Bootstrap logo"
                                />
                                <span className="fs-4">Ascentinel Path</span>
                            </Nav.Link>
                            <Nav.Link href="/missions">
                                <img
                                    src="/img/sword.png"
                                    width="30"
                                    height="30"
                                    className="d-inline-block align-top me-2"
                                    alt="React Bootstrap logo"
                                />
                                <span className="fs-4">Missions</span>
                            </Nav.Link>
                            <Nav.Link href="/stats">
                                <img
                                    src="/img/bar-chart.png"
                                    width="30"
                                    height="30"
                                    className="d-inline-block align-top me-2"
                                    alt="React Bootstrap logo"
                                />
                                <span className="fs-4">Stats</span>
                            </Nav.Link>
                            <Nav.Link href="/history">
                                <FontAwesomeIcon icon={faHourglass} size="2x" />
                                <span className="fs-4">History</span>
                            </Nav.Link>
                            <Nav.Link href="/me">
                                <img
                                    src="/img/brain-w.png"
                                    width="30"
                                    height="30"
                                    className="d-inline-block align-top me-2"
                                    alt="React Bootstrap logo"
                                />
                                <span className="fs-4">Pofile</span>
                            </Nav.Link>
                        </Nav>
                    </Offcanvas.Body>
                </Navbar.Offcanvas>
            </Container >
        </Navbar >
    )
}